import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
//const baseUrl = 'http://localhost:5000';


// Función para verificar si el nombre de una carpeta ya existe
const checkFolderName = async (path, folderName) => {
    try {
        const response = await axios.post(`${baseUrl}/api/check-folder-name`, {
            dirPath: path,
            folderName: folderName,
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {

        throw error; // Lanza el error para ser manejado en el componente React
    }
};

// Función para crear una nueva carpeta (opcional, si también quieres manejar la creación aquí)
const createFolder = async (path, folderName) => {
    try {
        const response = await axios.post(`${baseUrl}/api/create-folder`, {
            dirPath: path,
            folderName: folderName,
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error al crear la carpeta:', error);
        throw error; // Lanza el error para ser manejado en el componente React
    }
};

export { checkFolderName, createFolder };
